export default {
  table: {
    owner: "Owner",
    operator: "Operator",
    adjustment: "Adjustment",
    timeAt: "Time At"
  }
}